export const DOC_FLOW_PROFILE_HEADER_EDIT_TITLE_BTN_QA_NAME =
  'docFlowProfileHeaderEditTitle'
